import React from 'react';
import Footer from 'components/Footer/Footer';
import './legal.css';

const TermsOfService = () => {
  return (
    <>
    <div className="legal-wrapper">
      <div className="legal-content">
        <h1>TradeMagic.gg</h1>

        <section>
          <h2>Terms of Service (TOS)</h2>
          <p><strong>Effective Date: June 24, 2025</strong></p>
          <p>Welcome to TradeMagic.gg, a peer-to-peer Magic: The Gathering (MTG) card trading platform where users can create Have and Want lists, initiate trades, and earn points for successful exchanges.</p>
          <p>By using TradeMagic.gg, you agree to comply with and be legally bound by the following Terms of Service ("Terms"). If you do not agree to these Terms, do not use the service.</p>

          <hr />

          <h3>1. Eligibility</h3>
          <ul>
            <li>Users must be at least 13 years old to use the platform.</li>
            <li>You represent and warrant that you have the right and authority to enter into these Terms.</li>
          </ul>

          <h3>2. User Accounts</h3>
          <ul>
            <li>Provide accurate and complete information when creating your profile.</li>
            <li>Maintain confidentiality of your account.</li>
            <li>You may change your username at any time.</li>
          </ul>

          <h3>3. Public Profiles</h3>
          <ul>
            <li>Your profile may be publicly visible.</li>
            <li>Avoid posting personal data you don't want shared.</li>
            <li>Profile display is essential for community use.</li>
          </ul>

          <h3>4. Peer-to-Peer Trading</h3>
          <ul>
            <li>Users ship cards directly. TradeMagic does not handle items.</li>
            <li>Confirm trade receipt and resolve disputes promptly.</li>
            <li>Trades are at your own risk.</li>
          </ul>

          <h3>5. Points System</h3>
          <ul>
            <li>Points are platform-only currency and non-transferable.</li>
            <li>Rules and rewards may change at any time.</li>
          </ul>

          <h3>6. Trade Disputes</h3>
          <ul>
            <li>Report issues via support.</li>
            <li>We may issue point refunds or administrative actions.</li>
          </ul>

          <h3>7. Subscriptions</h3>
          <ul>
            <li>Subscriptions unlock extra features.</li>
            <li>Payments are non-refundable.</li>
            <li>Cancel any time to avoid renewal.</li>
          </ul>

          <h3>8. Community Standards</h3>
          <ul>
            <li>No harassment, fraud, or abuse.</li>
            <li>Messages may be reviewed.</li>
            <li>Repeated violations may result in bans.</li>
          </ul>

          <h3>9. Termination</h3>
          <ul>
            <li>We may suspend or delete accounts that violate the Terms.</li>
          </ul>

          <h3>10. Limitation of Liability</h3>
          <ul>
            <li>We are not liable for delivery, quality, or uptime issues.</li>
            <li>The service is "as-is" and subject to change.</li>
          </ul>

          <h3>11. Dispute Resolution</h3>
          <ul>
            <li>Disputes are resolved via binding arbitration in California.</li>
            <li>Class actions are waived.</li>
          </ul>

          <h3>12. Changes to Terms</h3>
          <ul>
            <li>Using the site after changes means you accept the new terms.</li>
          </ul>

          <h3>13. Contact</h3>
          <p>support@trademagic.gg</p>

          <hr />

        </section>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default TermsOfService;
